import openkit from "openkit";
import { API_URL } from "../config/config";
openkit.config.app_url = API_URL;

// register reservation in DB
const addToCart = async (entity, store, product, info, clientRequest) => {
  // common props
  let cartItem = {
    store_id: store?.id || product.gen_store_id,
    store_slug: store?.slug,
    store_name: store?.name,
    product_id: product.id,
    gen_name: product.gen_name,
    gen_files: product &&
      product.gen_files && [{ url: product.gen_files[0].url, alt: "room_pic" }],
    status: "cart",
    client_id: info.user.id,
    request: clientRequest,
    type: entity,
    // reservation_id: reservation.id,
  };

  // specific props

  if (entity === "restaurant") {
    cartItem = {
      ...cartItem,
      people: info.restaurant?.people,
      time: info.restaurant?.time,
      date: info.restaurant?.date.format(),
    };
  }
  if (entity === "experience") {
    cartItem = {
      ...cartItem,
      people: info.experience?.people,
      date: info.experience?.date,
      gen_price: product.gen_price * info.experience?.people,
      exp_language: info.experience?.language,
    };
  }
  if (entity === "rentacar") {
    cartItem = {
      type: entity,
      product_id: product.id,
      pickup_loc: info.rentacar?.pickup_loc,
      pickup_date: info.rentacar?.pickup_date?.format(),
      pickup_time: info.rentacar?.pickup_time,
      return_loc: info.rentacar?.return_loc,
      return_date: info.rentacar?.return_date?.format(),
      return_time: info.rentacar?.return_time,
    };
  }
  // if (entity === "goods") {
  //   cartItem = {
  //     ...cartItem,
  //   };
  // }

  if (entity === "event") {
    cartItem = {
      ...cartItem,
      gen_quantity: info.event.tickets,
      gen_price: product.gen_price * info.event.tickets,
    };
  }

  if (entity === "goods") {
    cartItem = {
      ...cartItem,
      // TODO CHANGE QUANTITY
      gen_quantity: 5,
    };
  }

  await openkit.data.create("c_reservation_lines", cartItem);
};

const removeFromCart = async (id) => {
  await openkit.data.delete("c_reservation_lines", id);
};

const getClientProducts = async (status, clientId) => {
  let query;
  if (status == "all") {
    query = {
      client_id: clientId,
    };
  } else {
    query = {
      client_id: clientId,
      status: status,
    };
  }
  // const products = await openkit.data.find("c_reservation_lines", query);
  const products = await openkit.custom.execute("post", "reservations", null, {
    query,
  });

  return products;
};

const getStoresWithReservation = async (clientId) => {
  const query = {
    client_id: clientId,
    status: { _ne: "cart" },
    // _select: ["store_id", "store_slug"],
    _select: ["store_id"],
  };

  const storesWithMessaging = await openkit.data.find(
    "c_reservation_lines",
    query
  );

  // get the name and image of the stores
  const stores = await openkit.data.find("c_stores", {
    id: { _in: storesWithMessaging.map((s) => s.store_id) },
    _select: ["id", "name", "main_image"],
  });

  return stores;
};

const getClientStoreMessages = async (clientId, storeId) => {
  try {
    const query = {
      client_id: clientId,
      store_id: storeId,
      _sort: {
        created_at: "DESC",
      },
    };

    const messages = await openkit.data.find("c_messages", query);

    return messages;
  } catch (error) {
    console.log("error :>> ", error);
  }
};

const registerMessage = async (text, clientId, storeId, senderId) => {
  if (!clientId || !storeId) return false;

  try {
    const query = {
      client_id: clientId,
      store_id: storeId,
      sender_id: senderId,
      text,
      // only needed to simulate writing a reply from the store from the front-end
      // for production convert in: read: true,
      read: senderId === clientId ? true : false,
    };

    const resp = await openkit.data.create("c_messages", query);

    return resp;
  } catch (error) {
    console.log("error :>> ", error);
  }
};

const getReservationItemsPerStore = async (status, clientId) => {
  const carts = await openkit.data.find("c_reservations", {
    client_id: clientId,
    status: status,
  });

  const cartsPerStore = [];
  for (const cart of carts) {
    const products = await openkit.data.find("c_reservation_lines", {
      reservation_id: cart.id,
      store_slug: cart.store_slug,
    });
    const index = cartsPerStore.findIndex(
      (r) => r?.store_slug === cart.store_slug
    );
    if (index === -1) {
      cartsPerStore.push({
        id: cart.id,
        store_slug: cart.store_slug,
        store_name: cart.store_name,
        status: cart.status,
        products: products,
      });
    } else {
      cartsPerStore[index].products.push(cart);
    }
  }
  return cartsPerStore;
};

const statusFromReservationMethod = async (product) => {
  let status;
  // const store = await openkit.data.findOne("c_stores", {
  //   slug: product.store_slug,
  // });
  if (product.auto_reserve === "immediatly") {
    status = "confirmed";
  } else if (product.auto_reserve === "period") {
    const dateLimit = new Date();
    dateLimit.setHours(dateLimit.getHours() + product.advance_period);
    let start;
    if (product.type === "lodge") start = new Date(product.check_in);
    if (product.type === "restaurant") start = new Date(product.date);
    if (product.type === "experience") start = new Date(product.date);
    if (product.type === "rentacar")
      start = new Date(
        product.reservation_time_range.split(",")[0].split('"')[1].slice(0, -3)
      );
    if (start < dateLimit) {
      status = "pending";
    } else {
      status = "confirmed";
    }
  } else {
    // status "never" or "other"
    status = "pending";
  }
  return status;
};

const submitCart = async (productsInCart) => {
  let status = "confirmed";
  for (const product of productsInCart) {
    status = await statusFromReservationMethod(product);
    const result = await openkit.data.update(
      "c_reservation_lines",
      product.id,
      {
        status,
      }
    );
  }
};

function randomString(length) {
  // lowercase and some chars removed to prevent reading difficulties ('O','0','I')
  const chars = "123456789ABCDEFGHJKLMNPQRSTUVWXYZ";
  let result = "";
  for (let i = length; i > 0; --i)
    result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}

const payReservations = async (confirmedReservations) => {
  for (const product of confirmedReservations) {
    const result = await openkit.data.update(
      "c_reservation_lines",
      product.id,
      {
        status: "paid",
        ticket: `${randomString(3)}-${randomString(3)}`,
        store_slug: product.store_slug, // apenas para não gerar erro no update
      }
    );
  }
};

const getUnreadMessages = async (clientId, stores) => {
  // unreadMessagesCount is an object, which key is the store ID,
  // and the value is the number of unread messages
  let unreadMessagesCount = {};

  for (const store of stores) {
    try {
      const query = {
        client_id: clientId,
        store_id: store.id,
        read: false,
        _select: ["read"],
      };

      const messageList = await openkit.data.find("c_messages", query);
      unreadMessagesCount[store.id] = messageList.length;
    } catch (error) {
      console.log("error :>> ", error);
    }
  }
  return unreadMessagesCount;
};

const setMessageAsRead = async (messageId) => {
  try {
    await openkit.data.update("c_messages", messageId, {
      id: messageId,
      read: true,
    });
  } catch (error) {
    console.log(error);
  }
};

const getStoreIdFromSlug = async (slug) => {
  try {
    const resp = await openkit.data.findOne("c_stores", {
      slug: slug,
      _select: ["id"],
    });
    return resp.id;
  } catch (error) {
    console.log("error :>> ", error);
  }
};

const dbFind = async (user, entity, query) => {
  let response;
  if (user?.roles?.includes("coworker")) {
    response = await openkit.custom.execute("post", entity, null, {
      query,
    });
  } else {
    response = await openkit.data.find(entity, query);
  }
  return response;
};

const dbFindOne = async (user, entity, query) => {
  let response;
  if (user.roles.includes("coworker"))
    response = await openkit.custom.execute("post", entity, null, {
      query,
    });
  else
    response = await openkit.data.findOne(entity, {
      ...query,
      gen_exclusive_coworkers: false,
    });
  return response.length ? response[0] : null;
};

const dbFindStoreWithSlug = async (slug) => {
  const store = await openkit.data.findOne("c_stores", {
    slug,
  });
  return store;
};

// const dbCreate = async () => {
//   const lodge = await openkit.data.create("c_order_lines", {
//     products: reservationsToDB[0].products,
//     client_id: 101,
//   });
// };

export const dbFilterStores = async (
  searchStr,
  type,
  reservationData,
  pagination,
  villages
) => {
  try {
    const query = {};
    searchStr && (query.name = { _like: searchStr });
    type === ""
      ? (query.type = { _in: ["lodge", "restaurant", "experience"] })
      : (query.type = type);
    query._sort = { is_associate: "ASC" };
    if (villages.length) {
      query._or = {};
      villages?.forEach((v) =>
        // query._or.push({ [v.toLowerCase().replace(" ", "_")]: true })
        {
          const villageName = v
            .toLowerCase()
            .replace(" ", "_")
            .replace(" ", "_")
            .replace("-", "_")
            .replace("-", "_");

          query._or[villageName] = true;
        }
      );
    }

    const stores = await openkit.data.find("c_stores", query, pagination);
    const count = await openkit.data.count("c_stores", query);

    return { stores, count };
  } catch (error) {
    console.log("error :>> ", error);
  }
};

export {
  openkit,
  addToCart,
  getReservationItemsPerStore,
  submitCart,
  getClientProducts,
  removeFromCart,
  payReservations,
  getStoresWithReservation,
  getClientStoreMessages,
  registerMessage,
  getUnreadMessages,
  setMessageAsRead,
  getStoreIdFromSlug,
  dbFind,
  dbFindOne,
  dbFindStoreWithSlug,
};
